import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <nav className={`navbar navbar-expand-md navbar-dark fixed-top ${scrolled ? "navbar-scrolled" : "navbar-transparent"}`} id="banner">
    {/* <nav className="navbar navbar-expand-md navbar-dark fixed-top" id="banner"> */}
      <div className="container">
        {/* Brand */}
        <Link className="navbar-brand" to="/">
          <img src="imgs/logo.png" alt="logo" className="logo" />
        </Link>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#collapsibleNavbar"
          aria-controls="collapsibleNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about-us">
                About Us
              </Link>
            </li>

            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle btn"
                id="navbardrop"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ background: "none", border: "none" }}
              >
                Loans
              </button>

              <div className="dropdown-menu" aria-labelledby="navbardrop">
                <Link className="dropdown-item" to="/home-loan">Home Loan</Link>
                <Link className="dropdown-item" to="/personal-loan">Personal Loan</Link>
                <Link className="dropdown-item" to="/business-loan">Business Loan</Link>
                <Link className="dropdown-item" to="/property-loan">Property Loan</Link>
                <Link className="dropdown-item" to="/education-loan">Education Loan</Link>
                <Link className="dropdown-item" to="/car-loan">Car Loan</Link>
                <Link className="dropdown-item" to="/bike-loan">Bike Loan</Link>
                <Link className="dropdown-item" to="/marriage-loan">Marriage Loan</Link>
                <Link className="dropdown-item" to="/gold-loan">Gold Loan</Link>
                <Link className="dropdown-item" to="/credit-card-loan">Loan on Credit Card</Link>
              </div>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/emi-calculator">
                EMI Calculator
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/blogs">
                Blogs
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/faqs">
                FAQs
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contact-us">
                Contact Us
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/apply-for-loan" className="btn login-btn mt-15 ml-50">
                Apply For Loan
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
